import { Styles } from "./styled";
import type { TrackingStatusChipColors } from "@lhd/features/TrackingTime/until";

interface IProps {
  label: string;
  chipColors?: TrackingStatusChipColors;
}
const Status = (props: IProps) => {
  const c = props.chipColors;
  return (
    <Styles
      $borderColor={c?.borderColor}
      $textColor={c?.color}
      $background={c?.background}
    >
      {props.label}
    </Styles>
  );
};
export default Status;
